export default __webpack_public_path__ + "static/media/GaugeImg5.eb4c1624.jpg";